module.exports = __webpack_public_path__ + "img/placeholder_sc2.e7c4ddf7.png";